<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { RemoveFormattingIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  // can't use unsetAllMarks because it doesn't operate on an empty selection
  // also want to be more specific about what marks are cleared by "Remove formatting" command
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .unsetBold()
    .unsetItalic()
    .unsetUnderline()
    .unsetStrike()
    .unsetCode()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="RemoveFormattingIcon"
    @click="run"
    @keydown.enter="run"
  >
    Remove formatting
  </SuggestionListItem>
</template>
